import type { TTicketsGateProps } from './Tickets.types.ts';
import { useTickets } from './use-tickets/index.ts';

export const TicketsGate = ({
  loading,
  failed,
  unavailable,
  children,
}: TTicketsGateProps) => {
  const { canViewTickets, isCheckingTicketing, ticketingError } = useTickets();

  if (isCheckingTicketing) {
    return loading;
  }

  if (ticketingError) {
    return failed;
  }

  if (!canViewTickets) {
    return unavailable;
  }

  return children;
};
